module.exports = __webpack_public_path__ + "media/application/images/icons/cross_white-709fe6e3dda1799c1bccd7a435bfc9b0.svg";